import nonVSSpacesBase from "./nonVSSpacesBase";
import { SpaceConfig } from "./spaceConfig";
import { SpaceId } from "./spaceIds";
import { UnknownSlugWorkaround } from "./spacesBase";

// This file is added to override description placeholder text for 1ES CloudMine( in Request a feature).

const spaceCloudMine: SpaceConfig = {
    ...nonVSSpacesBase,
    id: SpaceId.OneESCloudMine,
    displayName: "1ES CloudMine",
    slug: UnknownSlugWorkaround,
    reportSuggestionConfig : {
        ...nonVSSpacesBase.reportSuggestionConfig,
        descriptionPlaceholder : "To help us prioritize your ask, please include in your description\n\t\u2022 A business justification - why do you need this? Link associated KRs/one-pagers on scenario, if any.\n\t\u2022 When do you need this by(any deadlines/timelines)? \n\t\u2022 Any current work arounds? \nIf it is for a new data to be collected, provide a link to the API to collect.",
    }
};

export default spaceCloudMine;
